import Immutable from 'immutable';
import React from 'react';

import Tab from 'sharedreact/components/Tab';
import Toolbar from 'sharedreact/components/Toolbar';
import ToolbarGroup from 'sharedreact/components/ToolbarGroup';
import ToolbarTitle from 'sharedreact/components/ToolbarTitle';
import SortOrder from 'sharedreact/data/SortOrder';
import { translate } from 'sharedreact/utils/LanguageSupport';

import AgentsTable from 'workspaces/launcher/components/admin/AgentsTable';
import Agent from 'workspaces/launcher/data/Agent';

type Props = {
  index: number,
  activeTab: number,
  language: string,
  isFetching: boolean,
  agents: Immutable.List<Agent>,
  selection: Immutable.Set<string>,
  sortOrder: SortOrder,
  serverVersion: string,

  onLoad: () => void,
  onRemoveAgent: (agent: Agent) => void,
  onSortOrderChange: (sortOrder: SortOrder) => void,
  onItemSelect?: (id: string) => void
};

class AgentsTab extends React.Component<Props> {
  override componentDidMount (): void {
    if (this.props.activeTab === this.props.index) {
      this.props.onLoad();
    }
  }

  override componentDidUpdate (prevProps: Readonly<Props>): void {
    if (prevProps.activeTab !== this.props.activeTab && this.props.activeTab === this.props.index) {
      this.props.onLoad();
    }
  }

  override render (): React.ReactNode {
    const {
      index, activeTab,
      agents,
      selection, sortOrder,
      language, // eslint-disable-line no-unused-vars
      onRemoveAgent,
      onSortOrderChange, onItemSelect,
      isFetching,
      serverVersion
    } = this.props;

    return (
      <Tab index={index} activeIndex={activeTab}>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarGroup>
              <ToolbarTitle title={translate('launcher.admin.agents.title')} />
            </ToolbarGroup>
          </ToolbarGroup>
        </Toolbar>
        <div className='webappslauncher-scroll-container'>
          <div className='webappslauncher-stretch-container'>
            <AgentsTable
              language={language}
              agents={agents}
              selection={selection}
              showSelection
              sortOrder={sortOrder}
              emptyTableText='launcher.admin.agentslist.noagents'
              onSortOrderChange={onSortOrderChange}
              onRemoveAgent={onRemoveAgent}
              onItemSelect={onItemSelect}
              isFetching={isFetching}
              serverVersion={serverVersion}
            />
          </div>
        </div>
      </Tab>
    );
  }
}

export default AgentsTab;
